export const environment = {
  isLogin: true,
  isGoLive: false,
  production: false,
  RESOURCE_SERVER_URL:'${SOE_URL}/GroupSales',
  logOutURL: '${SOE_URL}/ELLandingPortal/user-persona',
  defaultBillingCurrency: '${SOE_DEFAULT_BILLING_CURRENCY}',
  defaultBillingFrequency: '${SOE_DEFAULT_BILLING_FREQUENCY}',
  GoogleApiKey: '${GOOGLE_API_KEY}',
  EnterpriseLinkKey: 'EnterpriseLink',
  language: 'en',
  compression: '${PF_G_COMPRESSION}',
  groupGPS: '${EL_G_groupGPS}',
  groupAML: '${EL_G_groupAML}',
  isFooterforPru: false,
  hideFooter: false,
  DISABLED_PRODUCER_INFO: true,
  defaultEmailLang: '${PF_G_DEFAULT_EMAIL_LANG}',
  role: {
    GFI: 'G_FI',
    GHR: 'G_HR',
    GIA: 'G_IA',
    GIC: 'G_IC',
    GIF: 'G_IF',
    GIR: 'G_IR',
    GME: 'G_ME',
    GOP: 'G_OP',
    GPA: 'G_PA',
    GPB: 'G_PB',
    GPC: 'G_PC',
    GPH: 'G_PH',
    GPO: 'G_PO',
    GPP: 'G_PP',
    GPS: 'G_IP',
    GPT: 'G_PT',
    GSL: 'G_SL',
    GUW: 'G_IU'
  },
  //Date Format
  DATE_FORMAT: '${SOE_DATE_FORMAT}',
  DATE_FORMAT1: '${SOE_DATE_FORMAT1}',
  API_COMMON_USERROLE_SERVER_URL: '${SOE_API_URL}/life/userrole-service',
  API_SERVER_URL: '${SOE_API_URL}/group',
  API_MESSAGE_SERVER_URL: '${SOE_API_URL}/group/message',
  API_USERROLE_SERVER_URL: '${SOE_API_URL}/group/userrole-service',
  API_CONFIGURATION_SERVER_URL: '${SOE_API_URL}/group-common/configuration',
  API_GROUPCONFIGURATION_SERVER_URL: '${SOE_API_URL}/group/configuration',
  API_PROSPECTS_SERVER_URL: '${SOE_API_URL}/group/prospects',
  API_ORGANIZATION_SERVER_URL: '${SOE_API_URL}/group/organizationclients',
  API_QUOTATION_SERVER_URL: '${SOE_API_URL}/group/quotation',
  API_PRINTS_SERVER_URL: '${SOE_API_URL}/group/prints',
  API_PAYMENTS_SERVER_URL: '${SOE_API_URL}/group/payments',
  API_UNDERWRITER_SERVER_URL: '${SOE_API_URL}/group/underwriter',
  API_CUSTOMERPORTAL_SERVER_URL:'${SOE_API_URL}/group/customerportal',
  API_CLAIM_SERVER_URL: '${SOE_API_URL}/group/claims',
  API_DMS_SERVER_URL: '${SOE_API_URL}/group/dms',
  API_USERINFO_SERVER_URL: '${SOE_API_URL}/group/userinfo',
  API_PROPOSAL_SERVER_URL: '${SOE_API_URL}/group/proposal',
  API_REGISTRATION_SERVER_URL: '${SOE_API_URL}/group/registration',
  API_QSN: '${SOE_QSNS_URL}/group/qsn-service',
  API_GROUP_INTEGRATION_URL: '${SOE_API_URL}/group/integration/group',
  API_UNDERWRITING_SERVER_URL: '${SOE_API_URL}/group/underwriting',
  API_DMS_LARGE_FILE_SERVER_URL: '${SOE_API_URL}/group/dms',
  ENV_ACTIVE_PROFILE: '${SOE_ACTIVE_PROFILE}',
  DISABLE_BENEFIT: true,
  HAS_CERTIFICATE_CUSTOMIZED: 'Yes',
  TERM_LIFE: "TERM LIFE",
  PERSONAL_ACCIDENT: "PERSONAL ACCIDENT",
  HEALTH: "HEALTH",
  MEDICAL: "MEDICAL",

  ORIGINAL_PROSPECT_ID: '${SOE_ORIGINAL_PROSPECT_ID}',
  CLIENT_NUMBER: '${SOE_CLIENT_NUMBER}',

  // ON_PREMISES
  ON_PREMISES: 'onPremise',
  // ON_CLOUD
  ON_CLOUD: 'cloud',
  // ON_PREMISES_CAS
  ON_PREMISES_CAS: 'CAS',
  // ON_CUSTOMIDP
  ON_CUSTOMIDP: 'customIDP',
  WEB_DOMAIN: "${SOE_DOMAIN}",
  
  // IDP-Configuration
  IDP: {
    issuer: '${SOE_IDP_URL}/oauth2/default',
    redirectUri: window.location.origin + '/GroupSales/proposal/proposal-dashboard',
    clientId: '${SOE_IDP_CLIENTID}',
    disablePKCE: false,
    responseType: 'code',
  },

  //CAS
  OAUTH2_CAS: {
    ClientId: '${SOE_CAS_CLIENTID}',
    LoginUrl: '${SOE_CAS_URL}/oauth2.0/authorize',
    logoutURL:'${SOE_CAS_URL}/logout',
    TokenUrl: '${SOE_CAS_URL}/oauth2.0/accessToken',
    CallbackUrl: window.location.origin + '/GroupSales',
  },
  
  // CustomerIDP
  ON_CUSTOMIDP_Auth: {
    // ClientId: '${SOE_CAS_CLIENTID}',
    baseUrl: '${PF_G_ON_CUSTOMIDP_BASEURL_SALES}',
    ClientId: '${PF_G_ON_CUSTOMIDP_CLIENTID_SALES}',
    clientSecret: '${PF_G_ON_CUSTOMIDP_CLIENTSECRET_SALES}',
    LoginUrl: '${PF_G_ON_CUSTOMIDP_LOGIN_URL_SALES}',
    logoutURL: '${PF_G_ON_CUSTOMIDP_LOGOUT_URL_SALES}',
    TokenUrl: '${PF_G_ON_CUSTOMIDP_TOKEN_URL_SALES}',
    redirectUri: window.location.origin + '/GroupSales',
    landingLogout: '${SOE_URL}/ELLandingPortal/user-persona',
    response_type: 'code', 
    scope: 'read', 
    x_api_key: '${SOE_COGNITO_XAPIKEY}',
  },
  
  // COGNITO-Configuration
  COGNITO: {
    SERVER_URL:'${SOE_COGNITO_URL}/',
    CAS_SERVER_URL: '${SOE_CAS_URL}/logout',
    ClientId: '${SOE_COGNITO_CLIENTID}',
    redirectUri: window.location.origin + '/GroupSales/proposal/proposal-dashboard',
    scope: 'openid',
    x_api_key: '${SOE_COGNITO_XAPIKEY}',
    response_type: 'CODE',
    landingLogout: '${SOE_URL}/ELLandingPortal',
    identity_provider: '${SOE_COGNITO_IDENTITY_PROVIDER}',
    
    
    //Add  soe landing portal
    LoginUrl: '${SOE_COGNITO_URL}/oauth2/authorize',
    TokenUrl: '${SOE_COGNITO_URL}/oauth2/token',
    UserInfo: '${SOE_COGNITO_URL}/oauth2/userInfo',
    logoutURL: '${SOE_COGNITO_URL}/logout',
    userProfileLogout: '${SOE_URL}/ELLandingPortal/user-persona',
    CallbackUrl:'${SOE_URL}/ELLandingPortal/el-web',
  },
  
  userName: '${SOE_PNC_USERNAME}',
  password: '${SOE_PNC_PASSWORD}',

  COGNITO_CONFIGURATION: {
      SERVER_URL: '${SOE_COGNITO_SERVER_URL}',
      client_id: '${SOE_COGNITO_CLIENTID}',
      redirectUri: window.location.origin + '/GroupSales/proposal/proposal-dashboard',
      scope: 'openid',
      response_type: 'code',
      x_api_key: '${SOE_COGNITO_XAPIKEY}'
  }
};
